import { useEffect, useState } from 'react'
import { useQuery } from 'urql'

import { useAppContext } from '~/contexts/app-context'

const useQueryWithPagination = ({ query, variables, requestPolicy, pause }) => {
  const { isServer } = useAppContext()

  const [result, setResult] = useState()
  const [cursor, setCursor] = useState()
  const [nextCursor, setNextCursor] = useState()

  useEffect(() => {
    setCursor(null)
    setNextCursor(null)
  }, [JSON.stringify(variables)])

  const getVariables = (variables, curs = cursor) => (curs ? { ...variables, cursor: curs } : variables)

  const [{ fetching, data, error }, reexecuteQuery] = useQuery({
    query,
    requestPolicy,
    variables: getVariables(variables),
    pause
  })

  // Prefetch the data
  useQuery({
    query,
    requestPolicy,
    variables: getVariables(variables, nextCursor),
    pause: isServer || pause || !nextCursor
  })

  const prefetchNextData = ({ nextCursor }) => nextCursor && setNextCursor(nextCursor)

  useEffect(() => {
    // Todo: this will be tidied up after QLJ test
    const dealsFeed = data?.dealsFeed || data?.dealsFeedCustomer
    const resultDealsFeed = result?.dealsFeed || result?.dealsFeedCustomer

    if (data && (!result || !dealsFeed.previousCursor)) {
      setResult(data)

      prefetchNextData(dealsFeed)
    } else if (data && result && resultDealsFeed.nextCursor !== dealsFeed.nextCursor && !error) {
      setResult({
        ...data,
        dealsFeed: {
          ...dealsFeed,
          deals: [...resultDealsFeed.deals, ...dealsFeed.deals]
        }
      })

      prefetchNextData(dealsFeed)
    }
  }, [data, error])

  const fetchMore = (nextCursor) => {
    setCursor(nextCursor)
  }

  return { fetching, data: result || data, error, fetchMore, reexecuteQuery }
}

export default useQueryWithPagination
